import React from "react";
import Modal from "react-modal";
import styled from "@emotion/styled";
import { defaultAction } from "@actions/defaultAction";
import { OPEN_CANCEL_SELL_ORDER_MODAL } from "@constants/actionTypes";
import { useDispatch, useSelector } from "react-redux";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(31, 32, 33, 0.9)"
  }
};

const ButtonDiv = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  grid-gap: 25px;
  margin-top: 43px;
  @media (max-width: 550px) {
    width: 85%;
    margin: 0 auto;
    margin-top: 24px;
  }
  @media (max-width: 500px) {
    margin-bottom: 20px;
  }
`;

const CloseButton = styled.button`
  height: 72px;
  border-radius: 36px;
  box-shadow: 0 9px 18px 0 rgba(31, 32, 33, 0.05);
  background-color: #ffffff;
  color: #ff9c1b;
  outline: none;
  border: 0;
  &:hover,
  &:active,
  &:focus {
    outline: none;
    border: 0;
  }
  @media (max-width: 550px) {
    height: 61px;
  }
  @media (max-width: 420px) {
    height: 55px;
  }
`;

const CancelButton = styled.button`
  height: 72px;
  border-radius: 36px;
  box-shadow: 0 9px 18px 0 rgba(253, 165, 54, 0.3);
  background-color: #ff9c1b;
  color: #ffffff;
  outline: none;
  border: 0;
  &:active,
  &:hover,
  &:focus {
    outline: none;
    border: 0;
  }
  @media (max-width: 550px) {
    height: 61px;
  }
  @media (max-width: 420px) {
    height: 55px;
  }
`;

const CancelSellOrderModal = ({ cancelSellOrder, onCancelAction = f => f }) => {
  const dispatch = useDispatch();
  const open = useSelector(
    state => state.popupsActions.showCancelSellOrderModal
  );
  const closeCancelSellOrderModal = () => {
    dispatch(defaultAction(OPEN_CANCEL_SELL_ORDER_MODAL, false));
  };
  return (
    <Modal
      className="Modal__Bootstrap modal-dialog cancel-order"
      closeTimeoutMS={150}
      isOpen={open}
      contentLabel="Support"
      style={customStyles}
    >
      <div className="modal-content modal-content-padding">
        <div className="modal-header mar-t-5">
          <div className="acct-modal-close-btn">
            <img
              src="https://cdn.cardcash.com/website/ui/elements/close.svg"
              className="fa fa-times"
              aria-hidden="true"
              onClick={closeCancelSellOrderModal}
              alt="close button"
            />
          </div>
          <div className="acct-modal-heading">Cancel Order</div>
        </div>
        <div
          className="modal-body modal-body-padding"
          style={{ fontSize: "14px" }}
        >
          <div className="acct-modal-text">
            Are you sure you want to cancel your order?
          </div>
          <div>
            <ButtonDiv>
              <CancelButton
                type="submit"
                onClick={() => {
                  onCancelAction();
                  cancelSellOrder();
                }}
              >
                Cancel Order
              </CancelButton>

              <CloseButton type="submit" onClick={closeCancelSellOrderModal}>
                Close
              </CloseButton>
            </ButtonDiv>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CancelSellOrderModal;
